module.exports = __webpack_public_path__ + "img/VL_16_01.5dbee08e.png";